/* eslint-disable import/prefer-default-export */
export const SearchProjects = {
  searchProjectsRequest: 'SEARCH_PROJECTS_PENDING',
  searchProjectsSuccess: 'SEARCH_PROJECTS_SUCCESS',

  updateSearchProjectRequest: 'UPDATE_SEARCH_PROJECT_PENDING',
  updateSearchProjectSuccess: 'UPDATE_SEARCH_PROJECT_SUCCESS',
};
